module.exports = __webpack_public_path__ + "img/nav-arrow.72ff7c0c.svg";